import React from "react";
import { Link } from "react-router-dom";
import Background from "./../images/new-updated-images/our-services/information-technology/our-service-information-technology-background.jpg";
import informationTechnologyImage from "./../images/new-updated-images/our-services/information-technology/our-service-information-technology-content.jpg";
import Footer from "../components/Layout/Footer";
import bnr3 from "./../images/lines.png";

export default function InformationTechnologyPage() {
  // Add title
  document.getElementById("titleText").innerText =
    "Staffing Connect - Our Services - Information Technology";

  return (
    <div className="page-wraper">
      <div className="page-content1 bg-white">
        <div
          className="dez-bnr-inr overlay-black-middle"
          style={{
            backgroundImage: `url(${Background})`,
            height: 580,
            marginTop:
              window.location.pathname == "/mobile/information-technology"
                ? "0rem"
                : "",
          }}
        >
          <div className="container">
            <div className="dez-bnr-inr-entry">
              <h1 className="text-white">
                <b style={{ display: "none" }}>
                  Staffing Connect - Our Services -
                </b>
                Information Technology
              </h1>
              <div className="breadcrumb-row">
                <ul className="list-inline">
                  <li>
                    {window.location.pathname ==
                    "/mobile/information-technology" ? (
                      "Home"
                    ) : (
                      <a href={"/"}>Home</a>
                    )}
                  </li>
                  <li>Our Services</li>
                  <li>Information Technology</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="content-block">
          <div className="section-full content-inner overlay-white-middle">
            <div className="container">
              <div className="row align-items-center m-b5 mb-0">
                <div className="section-head text-black text-center col-lg-12">
                  <h2 className="text-uppercase m-b0">
                    Information Technology{" "}
                  </h2>
                  {/* <h6 className="mb-0">
                    Welcome to Staffing Connect - Your Trusted Partner in
                    Information Technology Workforce Solutions!
                  </h6> */}
                </div>
              </div>

              <div className="row  m-b10">
                <div className="col-md-12 col-lg-6">
                  <img src={informationTechnologyImage} alt="" />
                </div>
                <div className="col-md-12 col-lg-6 ">
                  {/* <h2 className="m-b5"> Home Care</h2> */}
                  <p className="spacebar mt-3"></p>
                  <p className="mb-1">
                    Staffing Connect specializes in IT recruitment by connecting
                    top tech talent with leading companies. With a deep
                    understanding of the IT industry's evolving needs, Staffing
                    Connect streamlines the hiring process through targeted
                    sourcing, rigorous screening, and personalized service.
                    Whether you're seeking skilled developers, cybersecurity
                    experts, or IT project managers, Staffing Connect ensures
                    the right fit for both candidates and employers.
                  </p>

                  <h6 className="mt-2">Our Commitment:</h6>
                  <p>
                    Staffing Connect is committed to delivering exceptional
                    recruitment solutions tailored to the dynamic needs of the
                    IT industry. We prioritize quality, speed, and precision in
                    matching top-tier tech professionals with organizations
                    seeking to innovate and grow. Our dedicated team leverages
                    industry expertise, advanced sourcing strategies, and a deep
                    talent network to ensure every placement drives long-term
                    success. At Staffing Connect, we don’t just fill roles — we
                    build lasting partnerships that power the future of
                    technology.
                  </p>
                </div>

                <div className="col-md-12 col-lg-12 mt-2">
                  <h6>Why chose Staffing Connect?</h6>

                  <ol className="ml-4">
                    <li>
                      <b>Consultative, Personalized Approach:</b>
                      <ul className="ml-3">
                        <li>
                          Staffing Connect applies a "signature consultative
                          approach" to every search—whether a single key hire or
                          a large-scale staffing project. They emphasise truly
                          understanding both client and candidate needs,
                          ensuring strong alignment and fit.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <b>Strong Track Record of Customer Satisfaction:</b>
                      <ul className="ml-3">
                        <li>
                          User reviews consistently praise the agency's
                          responsiveness and tailored support:
                        </li>
                        <li>
                          They were prompt in their response and helped me find
                          a job that was a perfect fit … professional and
                          friendly.
                        </li>
                        <li>
                          They made the job search process much easier for me
                          and provided excellent guidance throughout … highly
                          recommend them.
                        </li>
                        <li>
                          These reflect positive experiences from candidates,
                          especially in fields like education and social
                          care—but the hallmarks of effective personal
                          connection, attentiveness, and intuitive understanding
                          are equally beneficial for IT roles.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <b>Focus on Long-Term Fit, Not Just Fill-In Roles:</b>
                      <ul className="ml-3">
                        <li>
                          Their personalized approach emphasizes{" "}
                          <b>matching the right person with the right job</b>{" "}
                          over simply filling vacancies. This commitment to fit
                          enhances job satisfaction and stability for both
                          clients and candidates—crucial in the fast-moving IT
                          sector.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </div>
                <div className="col-md-12 col-lg-12 mt-2">
                  <h6>
                    Staffing Connect – Powering IT teams with precision,
                    passion, and the perfect fit.
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div
            className=" content-inner-2 footerImage"
            style={{
              backgroundImage: "url( " + bnr3 + ")",
              backgroundPosition: "bottom",
              backgroundRepeat: "repeat-x",
            }}
          ></div>
        </div>
      </div>
    </div>
  );
}
